import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Typography,
  Button,
  makeStyles,
  Grid,
  Link as MuiLink,
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/CheckCircle';
import CheckingIcon from '@material-ui/icons/PlaylistAddCheck';
import BlockIcon from '@material-ui/icons/Block';
import ExclamationCircle from '@material-ui/icons/Report';
import Alert from '@material-ui/lab/Alert';
import clx from 'classnames';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import PATHS from 'constants/paths';
import CircularProgress from 'components/shared/CircularProgress';
import Api from 'api';
import IDVerificationComponent from './IDVerification';
import BankIDLoginDialog from './bankid-login-dialog';
import UploadedDocuments from './IDVerification/UploadedDocuments';

const Logo = ({ disabled }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 169 158">
    <g fill="none" fillRule="evenodd">
      <g fill={disabled ? '#183E4FAA' : '#183E4F'}>
        <g>
          <path d="M45.916 135.23c5.268 0 9.905 2.083 9.015 7.63l-1.005 6.257c-.355 2.211-.289 2.873 2.253 2.922l-2.583 5.878c-4.495.291-6.67-.167-7.75-2.046-2.384 1.422-5.006 2.129-7.814 2.129-5.093 0-6.845-2.541-6.392-5.378.213-1.34 1.03-2.67 2.328-3.756 2.794-2.336 9.715-2.673 12.42-4.462.236-2.002-.6-2.712-3.15-2.712-2.979 0-5.466.961-9.714 3.754l1.035-6.47c3.698-2.58 7.251-3.747 11.357-3.747zm32.032 0c4.892 0 7.172 3.008 6.407 7.968L82.075 158h-8.773l1.889-12.256c.342-2.244-.3-3.266-2.028-3.266-1.392 0-2.649.764-3.872 2.414L67.27 158H58.5l3.446-22.395h8.774l-.452 2.929c2.772-2.376 4.896-3.305 7.68-3.305zm22.058-7.436l-2.19 14.881 8.377-8.065H117l-10.759 9.971L114.866 158h-10.973l-6.656-10.808h-.082L95.567 158H86.82l4.438-30.206h8.747zm-78.437.93c7.265 0 9.048 3.578 8.525 6.855-.423 2.664-2.276 4.617-5.514 5.906 4.08 1.496 5.669 3.863 5.084 7.52-.733 4.616-4.87 8.066-10.257 8.066H0l4.514-28.347h17.055zm131.362 0c11.337 0 14.611 7.98 13.563 14.547-1.03 6.442-6.288 13.8-16.25 13.8h-16.53l4.532-28.347h14.685zm-19.681 0l-4.553 28.347h-10.304l4.554-28.347h10.303zm-87.452 19.348c-2.392 1.462-6.8 1.21-7.281 4.213-.228 1.42.685 2.46 2.151 2.46 1.427 0 3.164-.583 4.517-1.5-.091-.498-.047-1.042.113-2.043l.5-3.13zm-30.297-3.262h-3.332l-1.265 7.938h3.076c3.421 0 5.43-1.33 5.872-4.115.38-2.37-1.017-3.823-4.351-3.823zm134.677-9.357h-2.75l-2.379 14.884h2.707c4.978 0 7.721-2.37 8.535-7.439.595-3.741-.573-7.445-6.113-7.445zm-133.187-2.41h-2.95l-1.185 7.44h2.95c3.334 0 4.889-1.704 5.212-3.74.344-2.158-.692-3.7-4.027-3.7zM43.87 14.405c3.239 0 5.74.667 7.04 1.88.907.849 1.245 1.96.977 3.219-.26 1.215-1.64 2.797-3.71 4.223-5.866 4.066-4.85 8.28-4.397 9.477 1.358 3.601 5.892 5.544 9.462 5.544h7.58l-7.07 43.956h.121c-2.632 16.426-4.59 28.813-4.953 31.148H6.964c.804-5.165 11.305-70.804 11.97-75.091h.645l2.179.005h.502l1.696.004.446.001.62.001h.371l.172.001.451.001h.504l.058.001h.076c5.043-.027 9.69-2.3 11.844-5.793 2.106-3.388 1.305-7.02-2.076-9.482-1.127-.818-2.424-2.145-2.17-3.787.348-2.217 4.171-5.308 9.617-5.308zM109.119 0c38.623 0 65.555 16.776 58.858 58.635-5.415 33.793-32.973 55.218-66.709 55.218H93.27l5.425-34.104c13.664-.152 25.113-6.51 27.478-21.265 2.54-15.881-5.526-22.699-20.537-22.815.003-.024.003-.037.003-.037h-11.04c-2.542 0-5.808-1.395-6.655-3.641-.264-.696-.802-3.206 3.314-6.068 1.58-1.101 4.324-3.347 4.9-6.034.471-2.252-.198-4.429-1.845-5.967-1.876-1.757-5.01-2.69-9.061-2.69-6.765 0-11.939 4.042-12.527 7.813-.037.245-.061.532-.061.846 0 1.5.59 3.709 3.397 5.763 1.03.753 2.028 1.86 2.028 3.341 0 .679-.21 1.43-.723 2.267-1.608 2.612-5.341 4.378-9.301 4.4l-7.243-.017L66.526 0z" transform="translate(-100 -239) translate(100 239)" />
        </g>
      </g>
    </g>
  </svg>
);

Logo.propTypes = {
  disabled: PropTypes.bool,
};

const styles = makeStyles((theme) => ({
  bankid: {
    backgroundColor: '#469cbe',
    marginBottom: '8px',

    '&:hover': {
      backgroundColor: '#206F8F',
    },
  },
  img: {
    maxWidth: '20%',
  },
  button: {
    marginBottom: theme.spacing(1),
  },
  textInfo: {
    color: theme.palette.info.dark,
    textTransform: 'uppercase',

    '& svg': {
      verticalAlign: 'middle',
    },
  },
  textSuccess: {
    color: theme.palette.success.dark,
    textTransform: 'uppercase',

    '& svg': {
      verticalAlign: 'middle',
    },
  },
  textError: {
    color: theme.palette.error.dark,
    textTransform: 'uppercase',

    '& svg': {
      verticalAlign: 'middle',
    },
  },
  alert: {
    justifyContent: 'center',
  },
  clickable: {
    cursor: 'pointer',
  },
  alertBox: {
    maxWidth: '530px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
}));

const NotBookingValid = () => {
  return (
    <Box mb={4}>
      <Alert severity="info" elevation={3} style={{ textAlign: 'center' }}>
        <FormattedMessage
          id="userform.youHaveToComplete"
          defaultMessage="You have to complete your profile before you can id verify yourself"
        />.&nbsp;
        <Link to={PATHS.users.profile} style={{ color: '#2c6298' }}>
          <FormattedMessage
            id="Click here"
            defaultMessage="Click here"
          />
        </Link>
        &nbsp;
        <FormattedMessage
          id="userform.toComplete"
          defaultMessage="to complete your profile."
        />
      </Alert>
    </Box>
  );
};

const KycSubsection = ({
  activeTab,
  showBankIDRecommendation,
  user,
  isLoading,
  isUploading,
  documents,
  onSubmit,
  isStandalone,
}) => {
  const classes = styles();
  const [kycForm, setKycForm] = React.useState(null);
  const [showDocuments, setShowDocuments] = React.useState(isStandalone || user.kyc_status === 'FAILED');
  const [scaEnrollUrl, setScaEnrollUrl] = React.useState(null);

  const disableKyc = !user.booking_valid || ['PENDING', 'SUCCEDED'].includes(user.kyc_status);

  React.useEffect(() => {
    if (activeTab) {
      setKycForm(activeTab);
    }
  }, [activeTab]);

  const requireScaStep = async () => {
    const mangoUser = await Api.getMangoPayUser();

    if (mangoUser?.UserStatus !== 'ACTIVE') {
      const apiScaEnroll = await Api.scaEnroll({ sca_return_url: window.location.href });
      return apiScaEnroll;
    }
    return null;
  };

  React.useEffect(() => {
    const checkScaStep = async () => {
      const scaRedirectUrl = await requireScaStep();
      setScaEnrollUrl(scaRedirectUrl);
    };
    checkScaStep();
  }, []);

  return (
    <>
      {
        scaEnrollUrl && (
        <Grid container spacing={2} justifyContent="center">
          <Typography align="center" variant="body2" style={{ fontWeight: 'lighter', marginBottom: 5 }}>
            <FormattedMessage
              id="verification.kyc.sca.enrollment"
              defaultMessage="You need to complete the SCA enrollment process"
            />
          </Typography>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <Box textAlign="center" mb={4}>
              <Button
                color="primary"
                variant="contained"
                href={scaEnrollUrl}
                size="small"
                className={clx(classes.button)}
              >
                <FormattedMessage
                  id="sca.btn.requiresca"
                  defaultMessage="Go to Mangopay and complete verification"
                />
              </Button>
            </Box>
          </Grid>
        </Grid>
        )
      }
      {
        !disableKyc && showBankIDRecommendation && !isStandalone && (
          <Typography variant="body2" align="center">
            <FormattedMessage
              id="verification.other.options"
              defaultMessage="Identity documents"
            />
          </Typography>
        )
      }
      {
        !disableKyc && !showBankIDRecommendation && !isStandalone && (
          <Typography variant="body2" align="center">
            <FormattedMessage
              id="verification.kyc.explanation"
              defaultMessage="Verify your identity using your driving license, ID card or passport"
            />
          </Typography>
        )
      }
      {
        user.kyc_status === 'SUCCEDED' && (
          <>
            {
              showBankIDRecommendation && (
                <Box mb={4} textAlign="center" className={classes.alertBox}>
                  <Alert severity="info" elevation={3} icon={<ExclamationCircle />} classes={{ root: classes.alert }}>
                    <FormattedMessage
                      id="verification.bankid.recommendation"
                      defaultMessage="You are recommended to extend your verification with BankID if possible"
                    />
                  </Alert>
                </Box>
              )
            }
            <Box textAlign="center" className={classes.alertBox}>
              <Alert
                severity="success"
                elevation={3}
                icon={<CheckIcon />}
                classes={{ root: classes.alert }}
                onClick={() => setShowDocuments(!showDocuments)}
                className={classes.clickable}
              >
                <FormattedMessage
                  id="verification.kyc.success"
                  defaultMessage="You are verified with ID documents"
                />
              </Alert>
            </Box>
          </>
        )
      }
      {
        user.kyc_status === 'PENDING' && (
          <Box textAlign="center" className={classes.alertBox}>
            <Alert
              severity="warning"
              elevation={3}
              icon={<CheckingIcon />}
              classes={{ root: classes.alert }}
              className={classes.clickable}
              onClick={() => setShowDocuments(!showDocuments)}
            >
              <FormattedMessage
                id="verification.kyc.pending"
                defaultMessage="Your ID document verification status is pending"
              />
            </Alert>
          </Box>
        )
      }
      {
        user.kyc_status === 'FAILED' && (
          <Box mb={4} className={classes.alertBox}>
            <Alert
              severity="error"
              elevation={3}
              icon={<BlockIcon />}
              classes={{ root: classes.alert }}
              className={classes.clickable}
              onClick={() => setShowDocuments(!showDocuments)}
            >
              <FormattedMessage
                id="verification.kyc.failed"
                defaultMessage="Your ID document verification has failed"
              />
            </Alert>
          </Box>
        )
      }
      {
        showDocuments && (
          <UploadedDocuments uploadedKyc={documents} />
        )
      }
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={6} md={6} lg={6}>
          {
            !disableKyc && (
              <Box textAlign="center" mb={4}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => setKycForm(2)}
                  size="small"
                  className={clx(classes.button)}
                  disabled={!!scaEnrollUrl}
                  fullWidth
                >
                  <FormattedMessage
                    id="verification.alternative.id"
                    defaultMessage="Verify with driving license / ID card"
                  />
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => setKycForm(1)}
                  size="small"
                  className={clx(classes.button)}
                  disabled={!!scaEnrollUrl}
                  fullWidth
                >
                  <FormattedMessage
                    id="verification.alternative.passport"
                    defaultMessage="Verify with passport"
                  />
                </Button>
              </Box>
            )
          }
        </Grid>
      </Grid>
      {
        kycForm && (
          <>
            <IDVerificationComponent
              isLoading={isLoading}
              uploading={isUploading}
              uploadedKyc={documents}
              user={user}
              onSubmit={onSubmit}
              defaultSelected={kycForm}
            />
          </>
        )
      }
    </>
  );
};

KycSubsection.propTypes = {
  activeTab: PropTypes.number,
  showBankIDRecommendation: PropTypes.bool,
  user: PropTypes.shape({
    bankid_session: PropTypes.bool,
    bankid_verified_at: PropTypes.string,
    kyc_status: PropTypes.oneOf(['SUCCEDED', 'FAILED', 'PENDING', 'UNVERIFIED']),
    booking_valid: PropTypes.bool,
    can_change_name: PropTypes.bool,
    mango_user_id: PropTypes.string,
  }),
  isLoading: PropTypes.bool,
  isUploading: PropTypes.bool,
  documents: PropTypes.arrayOf(PropTypes.shape({})),
  onSubmit: PropTypes.func.isRequired,
  isStandalone: PropTypes.bool,
};

const BankIDSubsection = ({
  user,
  onBankIdLogin,
  showBankIDLogin,
}) => {
  const classes = styles();
  const [bankIdOpen, setBankIdOpen] = React.useState(false);
  const disableBankId = user.bankid_session || !user.booking_valid;

  return (
    <Box mb={2}>
      {
        (!user.bankid_verified_at || showBankIDLogin) && (
          <>
            <Box textAlign="center" mb={2}>
              <Typography variant="body2" component="p">
                <FormattedMessage
                  id="verification.explanation"
                  defaultMessage="Verify your identity by logging in with your BankID"
                />
              </Typography>
            </Box>
            <Grid container spacing={2} justifyContent="center">
              <Grid item xs={12} sm={6} md={6} lg={6}>
                <Box textAlign="center">
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={() => setBankIdOpen(true)}
                    size="small"
                    className={clx(classes.bankid)}
                    fullWidth
                    disabled={disableBankId}
                  >
                    <Logo disabled={disableBankId} />&nbsp;&nbsp;
                    {
                      !user.bankid_verified_at && (
                        <FormattedMessage
                          id="verification.bankid"
                          defaultMessage="Verify with BankID"
                        />
                      )
                    }
                    {
                      !!user.bankid_verified_at && (
                        <FormattedMessage
                          id="bankid.login"
                          defaultMessage="Login with BankID"
                        />
                      )
                    }
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </>
        )
      }
      {
        !!user.bankid_verified_at && !showBankIDLogin && (
          <Box my={4} textAlign="center" className={classes.alertBox}>
            <Alert severity="success" elevation={3} icon={<CheckIcon />} classes={{ root: classes.alert }}>
              <FormattedMessage
                id="verification.bankid.success"
                defaultMessage="You are verified with BankID"
              />
            </Alert>
          </Box>
        )
      }
      <BankIDLoginDialog
        title={null}
        open={bankIdOpen}
        onClose={() => setBankIdOpen(false)}
        onSuccess={onBankIdLogin}
      />
    </Box>
  );
};

BankIDSubsection.propTypes = {
  user: PropTypes.shape({
    bankid_session: PropTypes.bool,
    bankid_verified_at: PropTypes.string,
    kyc_status: PropTypes.oneOf(['SUCCEDED', 'FAILED', 'PENDING', 'UNVERIFIED']),
    booking_valid: PropTypes.bool,
    can_change_name: PropTypes.bool,
    mango_user_id: PropTypes.string,
  }),
  onBankIdLogin: PropTypes.func.isRequired,
  showBankIDLogin: PropTypes.bool,
};

const CompoundIDVerification = ({
  user,
  documents,
  isLoading,
  isUploading,
  onKycSubmit,
  onBankIdLogin,
  verificationMethods,
  showBankIDLogin,
}) => {
  const classes = styles();
  const [expanded, setExpanded] = React.useState(false);

  React.useEffect(() => {
    if (verificationMethods.length === 1 && verificationMethods[0] === 'KYC') {
      setExpanded(true);
    } else if (user.kyc_status !== 'UNVERIFIED') {
      setExpanded(true);
    }
  }, [verificationMethods]);

  const otherOptions = verificationMethods.includes('BANKID') && verificationMethods.includes('KYC') && !expanded && !user.bankid_verified_at;
  // const otherOptionsTwo = user.bankid_verified_at && !['PENDING', 'SUCCEDED', 'FAILED'].includes(user.kyc_status) && !expanded;

  if (isLoading) {
    return (
      <CircularProgress />
    );
  }

  return (
    <Box p={2} textAlign="center">
      {
        !user.booking_valid && (
          <NotBookingValid />
        )
      }
      <Box textAlign="center" mb={4}>
        <Box>
          <img
            src="data:image/png;base64,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"
            className={classes.img}
            alt="Verifiering"
          />
        </Box>
        <Typography variant="h6">
          <FormattedMessage
            id="Verify your identity"
            defaultMessage="Verify your identity"
          />
        </Typography>
      </Box>
      {
        verificationMethods.includes('BANKID') && (
          <BankIDSubsection
            user={user}
            onBankIdLogin={onBankIdLogin}
            showBankIDLogin={showBankIDLogin}
          />
        )
      }
      {
        otherOptions && (
          <Box textAlign="center" className={classes.alertBox}>
            <Typography variant="body2">
              <FormattedMessage
                id="verification.expand"
                defaultMessage="If you do not have BankID"
              />&nbsp;
              <MuiLink onClick={() => setExpanded(true)}>
                <FormattedMessage id="click here" defaultMessage="click here" />
              </MuiLink>
            </Typography>
          </Box>
        )
      }
      {
        verificationMethods.includes('KYC') && expanded && (
          <KycSubsection
            activeTab={user && user.kyc_status === 'FAILED' ? 1 : null}
            showBankIDRecommendation={verificationMethods.length > 1}
            isLoading={isLoading}
            isUploading={isUploading}
            documents={documents}
            user={user}
            onSubmit={onKycSubmit}
            isStandalone={verificationMethods.length === 1}
          />
        )
      }
    </Box>
  );
};

CompoundIDVerification.propTypes = {
  user: PropTypes.shape({
    bankid_session: PropTypes.bool,
    bankid_verified_at: PropTypes.string,
    kyc_status: PropTypes.oneOf(['SUCCEDED', 'FAILED', 'PENDING', 'UNVERIFIED']),
    booking_valid: PropTypes.bool,
    can_change_name: PropTypes.bool,
    mango_user_id: PropTypes.string,
  }),
  documents: PropTypes.arrayOf(PropTypes.shape({})),
  isLoading: PropTypes.bool,
  isUploading: PropTypes.bool,
  onKycSubmit: PropTypes.func,
  onBankIdLogin: PropTypes.func,
  verificationMethods: PropTypes.arrayOf(PropTypes.oneOf(['BANKID', 'KYC'])),
  showBankIDLogin: PropTypes.bool,
};

CompoundIDVerification.defaultProps = {
  verificationMethods: ['BANKID', 'KYC'],
};

export default CompoundIDVerification;
